import { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle`
	${css`
		.btn {
			outline: none !important;
			&.btn-quiet {
				background: #f5f5f5;
				color: #337ab7;
				border-color: transparent !important;

				&:hover,
				&:focus {
					background: #f0f0f0;
					color: #23527b;
				}
			}
		}
	`}
`;

export default GlobalStyle;
